import Bullet from 'components/prism/bullet';
import React from 'react';

export const Course = ({ course }) => {
    return (
        <div className="prism-content-box anchor-top">
            <div className="prism-banner-float flex flex-center">
                <Bullet type="course" />
            </div>
            <div className="prism-banner">
                <img src={course.image} />
            </div>
            <div className="prism-content">
                <div className="prism-progress">
                    <div className="prism-progress-bar">
                        <div style={{ width: `${course.progress}%` }} />
                    </div>
                    <div>{course.progress}%</div>
                </div>
                <h3>{course.title}</h3>
                {course.description && <p>{course.description}</p>}
                <button className="btn btn-primary" onClick={() => history.push(`/develop/learning`)}>
                    {course.progress ? 'Resume' : 'Start'}
                </button>
            </div>
        </div>
    );
};
